import styled from 'styled-components';
import { theme } from '../../styles/theme';

const { colors } = theme;

export const IntegracaoContainer = styled.div`
    width: 100%;
    max-width: 1100px;
    height: auto;
    margin: 24px auto 40px auto;
    padding: 0 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    @media only screen and (max-width: 780px) {
        padding: 0 16px;
    }
`;

export const PageCard = styled.div`
    width: 100%;
    background-color: ${theme.colors.gray.Cinza_13};
    border-radius: 16px;
    padding: 48px 40px;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media only screen and (max-width: 780px) {
        padding: 32px 20px;
    }
`;

export const Container = styled.div`
    width: 100%;
    max-width: 440px;
`;

export const StepHeader = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 24px;
`;

export const BackLink = styled.button`
    all: unset;
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    font-family: Lato;
    font-size: 13px;
    font-weight: 700;
    color: ${theme.colors.gray.Cinza_6};
    transition: color 0.2s ease;

    &:hover {
        color: ${theme.colors.green.Verde_AgroReceita};
    }
`;

export const ManualContainer = styled.div`
    width: 100%;
    max-width: 900px;
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const Section = styled.div`
    width: 100%;
    background-color: ${theme.colors.gray.Cinza_13};
    border-radius: 16px;
    padding: 28px 32px;
    display: flex;
    flex-direction: column;

    @media only screen and (max-width: 780px) {
        padding: 20px;
    }
`;

export const SectionTag = styled.span`
    align-self: flex-start;
    background-color: ${theme.colors.green.Fundo};
    color: ${theme.colors.green.Folha};
    font-family: Lato;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.05rem;
    text-transform: uppercase;
    padding: 4px 12px;
    border-radius: 20px;
    margin-bottom: 12px;
`;

export const CodeGrid = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    gap: 20px;
    margin-top: 16px;
`;

export const CodeCard = styled.div`
    width: 100%;
    background-color: ${theme.colors.gray.Cinza_2};
    border-radius: 12px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
`;

export const CodeCardHeader = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
    background-color: ${theme.colors.gray.Cinza_3};

    span {
        font-family: Lato;
        font-size: 12px;
        font-weight: 700;
        color: ${theme.colors.gray.Cinza_8};
        display: flex;
        align-items: center;
        gap: 8px;
    }
`;

export const CopyButton = styled.button`
    all: unset;
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    padding: 4px 10px;
    border-radius: 6px;
    font-family: Lato;
    font-size: 11px;
    font-weight: 700;
    color: ${theme.colors.gray.Cinza_8};
    transition: background-color 0.2s ease, color 0.2s ease;

    img {
        width: 14px;
        height: 14px;
    }

    &:hover {
        background-color: rgba(255, 255, 255, 0.08);
        color: #FFF;
    }

    &:active {
        transform: scale(0.95);
    }
`;

export const Pre = styled.pre`
    flex: 1;
    min-height: 0;
    margin: 0;
    padding: 16px;
    color: ${theme.colors.gray.Cinza_11};
    font-family: 'Courier New', Courier, monospace;
    font-size: 12px;
    line-height: 1.6;
    overflow-x: auto;
`;

export const RequisitosList = styled.ul`
    margin: 8px 0 0 0;
    padding-left: 18px;

    li {
        font-family: Lato;
        font-size: 14px;
        color: ${theme.colors.gray.Cinza_5};
        margin-bottom: 6px;
        line-height: 1.5;
    }
`;

export const Title = styled.h2`
    font-family: Lato;
    font-size: 24px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${theme.colors.gray.Cinza_5};
    margin-bottom: 0px;
    opacity: ${props => (props.cancelada ? "0.35" : "1")};
    margin-top: 20px;

`;

export const Text = styled.label`
    font-family: Lato;
    font-size: 14px;
    color: ${theme.colors.gray.Cinza_6};
    margin-bottom: 0px;
    margin-top: 10px;
    line-height: 1.5;
`;

export const FrameworksList = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 20px;

    margin: 0 auto;
    margin-top: 32px;
`;

export const SecTit = styled.h2`
    width: 100%;
    font-family: Lato;
    font-size: 18px;
    font-weight: 800;
    color: ${colors.gray.Cinza_2};
    margin: 32px 0 6px;
`;

export const SecSub = styled.p`
    width: 100%;
    font-size: 13px;
    color: ${colors.gray.Cinza_6};
    margin-bottom: 16px;
`;

export const Grid = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 16px;

    @media (max-width: 760px) {
        grid-template-columns: 1fr;
    }
`;

export const FrameworksItem = styled.div`
    width: 100%;
    min-height: 120px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;

    background-color: ${theme.colors.white.Branco};
    border-radius: 12px;
    padding: 20px;

    outline: 2px solid transparent;
    outline-offset: -2px;
    transition: outline-color 0.2s ease;
    cursor: pointer;

    &:hover {
        outline-color: ${theme.colors.green.Verde_AgroReceita};
    }
`;

export const Card = styled.div`
    background: ${colors.gray.Cinza_13};
    border-radius: 16px;
    padding: 22px;
    display: flex;
    flex-direction: column;
    gap: 14px;
`;

export const FrameworkCard = styled(Card)`
    cursor: pointer;
    transition: transform .15s, box-shadow .15s;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 16px rgba(29,33,41,.08);
    }
`;

export const CardTop = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;

    background-color: ${theme.colors.white.Branco};
    border-radius: 12px;
    padding: 20px;

    outline: 2px solid transparent;
    outline-offset: -2px;
    transition: outline-color 0.2s ease;

    &:hover {
        outline-color: ${theme.colors.green.Verde_AgroReceita};
    }
`;

export const LogoBox = styled.div`
    width: 44px;
    height: 44px;
    border-radius: 10px;
    background: ${colors.white.Branco};
    border: 1px solid ${colors.gray.Cinza_11};
    display: grid;
    place-items: center;
    flex-shrink: 0;
    overflow: hidden;

    img {
        max-width: 34px;
        max-height: 34px;
    }
`;

export const Tags = styled.div`
    margin-left: auto;
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
    justify-content: flex-end;
`;

export const Tag = styled.span`
    font-weight: 800;
    font-size: 9px;
    letter-spacing: .08em;
    text-transform: uppercase;
    padding: 4px 10px;
    border-radius: 500px;
    white-space: nowrap;

    background: ${props =>
        props.variant === 'nativa' ? colors.green.Verde_AgroReceita :
        props.variant === 'pluga' || props.variant === 'conectado' ? 'rgba(88,155,255,.14)' :
        colors.green.Fundo};

    color: ${props =>
        props.variant === 'nativa' ? colors.white.Branco :
        props.variant === 'pluga' || props.variant === 'conectado' ? '#2f6fd1' :
        colors.green.Folha};
`;

export const CardTitle = styled.h3`
    font-size: 18px;
    font-weight: 800;
    color: ${colors.gray.Cinza_2};
`;

export const CardDesc = styled.p`
    font-size: 13px;
    color: ${colors.gray.Cinza_6};
    line-height: 1.55;
    flex-grow: 1;

    b {
        color: ${colors.gray.Cinza_2};
        font-weight: 700;
    }
`;

export const Recursos = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const RecursoItem = styled.span`
    font-size: 12px;
    color: ${colors.gray.Cinza_5};
    display: flex;
    align-items: center;
    gap: 8px;

    svg {
        flex-shrink: 0;
    }
`;

export const ManualLink = styled.a`
    font-size: 13px;
    color: ${colors.blue.Azul_link} !important;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;

    label {
        cursor: pointer;
        color: ${theme.colors.gray.Cinza_6};
        font-family: Lato;
    }
`;

export const Acoes = styled.div`
    display: flex;
    gap: 8px;
    flex-wrap: wrap;

    > div {
        flex: 1;
        min-width: 140px;
    }
`;

export const VoltarLink = styled.div`
    width: 100%;
    font-size: 12px;
    font-weight: 700;
    color: ${colors.blue.Azul_link};
    cursor: pointer;
    margin-bottom: 16px;

    &:hover {
        text-decoration: underline;
    }
`;

export const Col = styled.div`
    width: ${props => (props.width ? props.width : "100%")};
    height: 40%;
    display: flex;
    flex-direction: column;
    align-items: ${props => (props.alignItems ? props.alignItems : "flex-start")};
    justify-content: center;
    font-size: 12px;
    cursor: pointer;

    label {
        cursor: pointer;
        color: ${theme.colors.gray.Cinza_6};
        font-family: Lato;
    }
`;

